import React, {useContext, useEffect} from 'react';
import {observer} from "mobx-react";
import {useLocation} from "react-router-dom";
import {StoreContext} from "../../store.context";

const InactivityUtil: React.FC<any> = observer(() => {
    const location = useLocation();

    const {
        appStore: {
            authStore,
            lastNavigationTime,
            setLastNavigationTime,
            inactive,
            setInactive
        },
    } = useContext(StoreContext);

    useEffect(() => {
        const timer = setInterval(() => {
            const currentTime = Date.now();
            const timeDifference = currentTime - lastNavigationTime;
            const twoHours = Number(process.env.REACT_APP_UI_SESSION_TIMEOUT);

            if (timeDifference > twoHours) {
                clearInterval(timer);
                setInactive(true);
            }
        }, 60000);

        return () => {
            clearInterval(timer);
        };
    }, [lastNavigationTime, setInactive]);

    useEffect(() => {
        const timer = setInterval(async () => {
            if (!inactive) {
                await authStore.refresh();
            }
        }, 60000);

        return () => {
            clearInterval(timer);
        };
    }, [inactive, authStore])

    useEffect(() => {
        setLastNavigationTime(Date.now());
    }, [location.pathname, setLastNavigationTime]);

    return (<></>)
});

export default InactivityUtil;